import { conversionCopy } from "@/lib/conversionCopy";
import { useLanguage } from "@/lib/useLanguage";

const cards = [
  { emoji: "🏆", titleKey: "why.1.title", descKey: "why.1.desc" },
  { emoji: "⚡", titleKey: "why.2.title", descKey: "why.2.desc" },
  { emoji: "💬", titleKey: "why.3.title", descKey: "why.3.desc" },
  { emoji: "📋", titleKey: "why.4.title", descKey: "why.4.desc" },
];

const WhyChooseUs = () => {
  const { t: originalT, language } = useLanguage();
  const overrides: Record<string, string> = conversionCopy[language].homeText;
  const t = (key: string) => overrides[key] ?? originalT(key);

  return (
    <section className="bg-secondary py-8 lg:py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-[40px] font-bold text-primary text-center mb-14">
          {t("why.heading")}
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((card) => (
            <div
              key={card.titleKey}
              className="bg-card rounded-xl p-8 border border-border shadow-[0_2px_16px_rgba(0,0,0,0.08)]"
            >
              <div className="text-3xl mb-4">{card.emoji}</div>
              <h3 className="text-base font-bold text-foreground mb-2">
                {t(card.titleKey)}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {t(card.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
